export default {
  "cashierReport.shiftClose": "締め済み",
  "cashierReport.shiftOpen": "勤務中",
  "cashierReport.th.deviceName": "デバイス名",
  "cashierReport.th.deviceType": "デバイス種類",
  "cashierReport.th.closeUserName": "最終利用アカウント名",
  "cashierReport.th.version": "APKバージョン",
  "cashierReport.th.operatingTime": "稼働時間",

  /** record detail dialog */
  "cashierReport.dialog.title": "レジ詳細",

  "cashierReport.dialog.salesInCashs": "現金",
  "cashierReport.dialog.yenSign": "¥",

  "cashierReport.dialog.actualAmountTable": "理論レジ内金額の内訳計算表",
  "cashierReport.dialog.openAmount": "釣銭準備金",
  "cashierReport.dialog.salesInCash": "本日現金売上",
  "cashierReport.dialog.saleInCash": "本日現金販売",
  "cashierReport.dialog.ticket": "チケット",
  "cashierReport.dialog.concession": "コンセッション",
  "cashierReport.dialog.commercial": "物販",
  "cashierReport.dialog.salesRefundInCash": "本日現金払戻",
  "cashierReport.dialog.preSaleInCash": "前受金（先売等）",
  "cashierReport.dialog.advanceTicketSale": "劇場前売券販売",
  "cashierReport.dialog.nationalTicketSales": "全国共通券販売",
  "cashierReport.dialog.refundUpdateDetails": "レジ締め済等取引の追加/払戻/修正",

  "cashierReport.dialog.closingCashTypeTable": "レジ締め金種表",
  "cashierReport.dialog.currentTime": "最終更新日時：",
  "cashierReport.dialog.bills": "円札",
  "cashierReport.dialog.coins": "円玉",
  "cashierReport.dialog.qty": "枚",

  "cashierReport.dialog.banlance": "レジ金精算表",
  "cashierReport.dialog.cashierAmount": "レジ金額",
  "cashierReport.dialog.cashierActualAmount": "理論レジ内金額",
  "cashierReport.dialog.excessAmount": "過不足金",
  "cashierReport.dialog.nextOpenAmount": "繰越釣銭準備金",
  "cashierReport.dialog.safeDeposit": "金庫預入金",

  "cashierReport.dialog.receivable": "売掛金",
  "cashierReport.dialog.advanceCouponType": "劇場前売券/優待券",
  "cashierReport.dialog.breakdownTable": "レジ内金額の内訳計算表",
  "cashierReport.dialog.refundBreakdownTable": "レジ締め済取引の払戻",
  "cashierReport.dialog.settlement": "決済",
  "cashierReport.dialog.nationalTicket": "全国共通券",
  "cashierReport.dialog.coupon": "劇場引換券",
  "cashierReport.dialog.advanceCoupon": "劇場前売券",
  "cashierReport.dialog.couponType": "劇場優待券",
  "cashierReport.dialog.total": "合計",

  "cashierReport.dialog.th.content": "内容",
  "cashierReport.dialog.th.amount": "金額",
  "cashierReport.dialog.th.cashType": "金種",
  "cashierReport.dialog.th.cashQty": "枚数",
  "cashierReport.dialog.th.receivableType": "売掛金種別",
  "cashierReport.dialog.th.receivableName": "売掛金名",
  "cashierReport.dialog.th.salesQty": "理論件数",
  "cashierReport.dialog.th.actualQty": "実件数",
  "cashierReport.dialog.th.excessQty": "過不足（件数）",
  "cashierReport.dialog.th.salesAmount": "理論売上",
  "cashierReport.dialog.th.actualAmount": "実売上",
  "cashierReport.dialog.th.excessAmount": "過不足（売上）",



  "cashierReport.dialog.formField.device": "デバイス",
  "cashierReport.dialog.formField.comment": "コメント",
  "cashierReport.dialog.formField.selectPlaceHolder": "選択してください",
  "cashierReport.dialog.formField.inputPlaceHolder": "入力してください"
};